import BackgroundRewardsPage from './Page'

export default BackgroundRewardsPage
